/**
 * Base error class returned from API
 */
export class ApiError {
	/** number indicating the error such as 500, 404 - refer to HTTP StatusCodes */
	status = null;

	/** string representation of the error code such as "Bad Request", "Internal Server Error" - refer to the HTTP StatusCodes */
	errorCode = null;

	/** string of the error message such as exception details, etc. */
	message = null;

	/** string of additional details such as API trace results, etc. */
	moreInfo = null;

	/** Array of validation errors - refer to ApiValidationError */
	validationErrors = [];

	/**
	 * Constructor that accepts an error object
	 * @param {number} [error.status]
	 * @param {string} [error.errorCode]
	 * @param {string} [error.message]
	 * @param {string} [error.moreInfo]
	 * @param {Array} [error.validationErrors]
	 */
	constructor(error = {}) {
		this.status = error.status ?? null;
		this.errorCode = error.errorCode ?? null;
		this.message = error.message ?? null;
		this.moreInfo = error.moreInfo ?? null;
		this.validationErrors = error.validationErrors ?? [];
	}
}
